import React from 'react';
import { Select } from 'antd';

const { Option } = Select;

const getFullName = (user) => `${user?.first_Name || ''} ${user?.last_Name || ''}`.trim();

export default function ViewAsSelector({
   users = [],
   value,
   defaultValue,
   onChange,
   label = 'View as',
   placeholder = 'Search to Select',
   className = 'brainee-module-view-as',
   dropdownClassName = 'brainee-module-view-as-dropdown',
   selectStyle,
   disabled = false,
}) {
   const selectedValueProps = value !== undefined ? { value } : { defaultValue };

   return (
      <label className={['view-as-selector', className].filter(Boolean).join(' ')}>
         <span>{label}</span>
         <Select
            showSearch
            dropdownClassName={['view-as-selector-dropdown', dropdownClassName].filter(Boolean).join(' ')}
            placeholder={placeholder}
            optionFilterProp="children"
            filterOption={(input, option) =>
               String(option?.children || '').toLowerCase().includes(input.toLowerCase())
            }
            onChange={onChange}
            disabled={disabled}
            style={selectStyle}
            {...selectedValueProps}
         >
            {users.map((item) => {
               const fullname = getFullName(item);
               return (
                  <Option value={item.id} key={item.id}>{fullname}</Option>
               );
            })}
         </Select>
      </label>
   );
}
